import {
  isWeixin,
  appid,
  isApp,
  dateFn,
  exclusiveidFn,
  pointParams,
  download_dialog,
  isWx
} from './config'
import wx from 'weixin-js-sdk'
let skufunc = {
  //购物车-规格&分组列表·特殊购物车-规格
  openSku_cart(items, idx, that) {
    if (items.inventory == 1) {
      that.productNum = items.num
      that.listItem = items
      that.itemIndex = idx
      that.productId = that.listItem.itemid
      that.maxNum = parseInt(that.listItem.canbuycnt)
      that.goods.title = items.name
      that.skuprice = parseFloat(items.sales_price).toFixed(2)
      that.skucostprice = parseFloat(items.cost_price).toFixed(2)
      that.goods.picture = items.img_path
      that.skuname = items.spec
      that.sku.tree = []
      that.sku.list = []
      that.listItem.normlist.map(function (item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function (itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      that.listItem.sku_rule_list.map(function (item, index) {
        var stockNum =
          item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0
            ? 0
            : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: parseFloat(item.sales_price).toFixed(2),
          original_price: parseFloat(item.price).toFixed(2),
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: parseInt(item.num),
          stock_num: stockNum,
          islimit: item.islimit,
          issale: item.issale,
          cost_price: item.cost_price,
          temp_sales_price: parseFloat(item.sales_price).toFixed(2),
          ismorediscounts: item.ismorediscounts,
          morediscountslabel: item.morediscountslabel,
          morediscountsmoney: item.morediscountsmoney,
          morediscountsitemnum: item.morediscountsitemnum,
          issuperposition: item.issuperposition,
          morediscountdesc: item.morediscountdesc,
          morediscountsname: item.morediscountsname
        })
        if (item.skuid == that.listItem.skuid) {
          that.initialSku = {
            id: item.skuid,
            price: parseFloat(item.sales_price).toFixed(2),
            original_price: parseFloat(item.price).toFixed(2),
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            selectedNum: parseInt(item.num),
            stock_num: stockNum,
            islimit: item.islimit,
            issale: item.issale,
            cost_price: item.cost_price,
            temp_sales_price: parseFloat(item.sales_price).toFixed(2),
            ismorediscounts: item.ismorediscounts,
            morediscountslabel: item.morediscountslabel,
            morediscountsmoney: item.morediscountsmoney,
            morediscountsitemnum: item.morediscountsitemnum,
            issuperposition: item.issuperposition,
            morediscountdesc: item.morediscountdesc,
            morediscountsname: item.morediscountsname
          }
        }
      })
      that.showsku = true
    }
  },
  //店铺福利-规格
  openSku_compro(items, idx, that) {
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    that.sku.tree = []
    that.sku.list = []
    that.listItem.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.listItem.sku_rule_list.map(function (item) {
      // if (item.issale === 1 && item.islimit === 0) {
      var stockNum =
        parseInt(item.issale) === 1 && parseInt(item.islimit) === 0 && item.is_can_buy != 0
          ? parseInt(item.canbuycnt)
          : 0
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        stock_num: stockNum
      })
      if (!that.initialSku.id && item.skuid === that.listItem.skuid) {
        let initialSku = {
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: items.num
        }
        that.initialSku = initialSku
      }
      // }
    })
    console.log('sku.list', that.sku.list)
    console.log('initialSku', that.initialSku)
    that.showsku = true
  },
  //商品组件productItem.vue-规格
  openSku_proitem(items, idx, that) {
    that.daiIndex = 0
    that.zcIndex = 0
    items.sku_rule_list.map(function (item) {
      if (item.issale == 1 && item.canbuycnt > 0) {
        if (item.islimit == 1) {
          // 待售
          that.daiIndex++
        } else if (item.islimit == 0) {
          that.zcIndex++
        }
      }
    })
    if (that.zcIndex <= 0 && that.daiIndex <= 0) {
      that.$toast('当前商品无货')
      return
    }
    that.productNum = items.num
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.skucostprice = parseFloat(items.cost_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    // console.log('skuValueToast:', that.skuValueToast)
    if (
      !that.skuValueToast ||
      !that.skuValueToast.selectedSkuComb ||
      that.skuValueToast.selectedSkuComb.stock_num <= 0
    ) {
      that.goods.picture = items.img_path
      that.skuname = ''
      that.sureGray = true
      that.i = 0
    }
    var arg = isApp()
    if (!isWeixin()) {
      if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists && arg == '') {
        that.$store.commit('PATH_VALUE', JSON.stringify({ itemid: that.$route.query.itemid }))
        that.$router.push({
          path: '/login',
          query: {
            routeval: 'productdetail'
          }
        })
      } else {
        that.sku.list = []
        that.sku.tree = []
        items.normlist.map(function (item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function (itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function (item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum =
            item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
              ? 0
              : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum,
            cost_price: item.cost_price
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
          }
          // }
        })
        // console.log('that.skuprice:', that.skuprice)
        that.showsku = true
      }
    } else {
      that.sku.tree = []
      that.sku.list = []
      items.normlist.map(function (item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function (itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      items.sku_rule_list.map(function (item) {
        // if (item.issale === 1 && item.islimit === 0) {
        var stockNum = item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: item.sales_price,
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          payfreight: item.freightrule.payfreight,
          isdiscount: item.isdiscount,
          isfullgift: item.isfullgift,
          ispresale: item.ispresale,
          presaletime: item.presaletime,
          stock_num: stockNum,
          cost_price: item.cost_price
        })
        if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
          if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
            that.skuValueToast.selectedSkuComb.stock_num = stockNum
            if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
              that.goods.picture = items.img_main_path
              that.skuname = ''
              that.sureGray = true
            }
          }
        }
        that.sku.stock_num += stockNum
        if (stockNum > 0 && that.i == 0) {
          that.skuname = item.sku_name
          that.goods.picture = item.spec_imgpath
          that.goods.isdiscount = item.isdiscount
          that.goods.isfullgift = item.isfullgift
          that.goods.payfreight = item.freightrule.payfreight
          that.goods.ispresale = item.ispresale
          that.goods.presaletime = item.presaletime
          that.initialSku = {
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            selectedNum: 1
          }
          that.i = 1
        } else if (stockNum <= 0 && that.i == 0) {
          that.skuprice = parseFloat(items.sales_price).toFixed(2)
          that.skucostprice = parseFloat(items.cost_price).toFixed(2)
          // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
          // } else {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
          // }
          // that.initialSku = {}
          that.i = 1
        }
        // }
      })
      that.showsku = true
    }
  },
  //函金靓-精选好物-规格
  openSku_bspl(items, idx, that) {
    if (items.inventory != 1) {
      return
    }
    that.productNum = items.num
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    that.sku.tree = []
    that.sku.list = []

    that.listItem.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.listItem.sku_rule_list.map(function (item) {
      var stockNum =
        item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0
          ? 0
          : parseInt(item.canbuycnt)
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        stock_num: stockNum,
        islimit: item.islimit,
        issale: item.issale,
        cost_price: item.cost_price,
        temp_sales_price: parseFloat(item.sales_price).toFixed(2)
      })
      if (item.skuid == that.listItem.skuid) {
        that.initialSku = {
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: parseInt(item.num),
          cost_price: item.cost_price,
          temp_sales_price: parseFloat(item.sales_price).toFixed(2)
        }
      }
    })
    that.showsku = true
  },
  //领券-可用商品-规格
  openSku_couponproduct(items, idx, that) {
    // && items.issale != 0
    that.productNum = items.num
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    that.sku.tree = []
    that.sku.list = []
    that.listItem.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.listItem.sku_rule_list.map(function (item, index) {
      var stockNum =
        item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 ? 0 : parseInt(item.canbuycnt)
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        stock_num: stockNum,
        islimit: item.islimit,
        issale: item.issale
      })
      if (item.skuid == that.listItem.skuid) {
        that.initialSku = {
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: parseInt(items.num)
        }
      }
    })
    that.showsku = true
  },
  //畅销榜-规格
  openSku_bestsell(items, idx, that) {
    that.daiIndex = 0
    that.zcIndex = 0
    items.sku_rule_list.map(function (item) {
      if (item.issale == 1 && item.canbuycnt > 0) {
        if (item.islimit == 1) {
          // 待售
          that.daiIndex++
        } else if (item.islimit == 0) {
          that.zcIndex++
        }
      }
    })
    if (that.zcIndex <= 0 && that.daiIndex <= 0) {
      that.$toast('当前商品无货')
      return
    }
    that.productNum = items.num
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    // console.log('skuValueToast:', that.skuValueToast)
    if (
      !that.skuValueToast ||
      !that.skuValueToast.selectedSkuComb ||
      that.skuValueToast.selectedSkuComb.stock_num <= 0
    ) {
      that.goods.picture = items.img_main_path
      that.skuname = ''
      that.sureGray = true
      that.i = 0
    }
    if (!isWeixin()) {
      if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
        that.$store.commit('PATH_VALUE', JSON.stringify({ itemid: that.$route.query.itemid }))
        that.$router.push({
          path: '/login',
          query: {
            routeval: 'productdetail'
          }
        })
      } else {
        that.sku.list = []
        that.sku.tree = []
        items.normlist.map(function (item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function (itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function (item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum =
            item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
              ? 0
              : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
          }
          // }
        })
        // console.log('that.skuprice:', that.skuprice)
        that.showsku = true
      }
    } else {
      that.sku.tree = []
      that.sku.list = []
      items.normlist.map(function (item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function (itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      items.sku_rule_list.map(function (item) {
        // if (item.issale === 1 && item.islimit === 0) {
        var stockNum = item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: item.sales_price,
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          payfreight: item.freightrule.payfreight,
          isdiscount: item.isdiscount,
          isfullgift: item.isfullgift,
          ispresale: item.ispresale,
          presaletime: item.presaletime,
          stock_num: stockNum
        })
        if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
          if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
            that.skuValueToast.selectedSkuComb.stock_num = stockNum
            if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
              that.goods.picture = items.img_main_path
              that.skuname = ''
              that.sureGray = true
            }
          }
        }
        that.sku.stock_num += stockNum
        if (stockNum > 0 && that.i == 0) {
          that.skuname = item.sku_name
          that.goods.picture = item.spec_imgpath
          that.goods.isdiscount = item.isdiscount
          that.goods.isfullgift = item.isfullgift
          that.goods.payfreight = item.freightrule.payfreight
          that.goods.ispresale = item.ispresale
          that.goods.presaletime = item.presaletime
          that.initialSku = {
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            selectedNum: 1
          }
          that.i = 1
        } else if (stockNum <= 0 && that.i == 0) {
          that.skuprice = parseFloat(items.sales_price).toFixed(2)
          // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
          // } else {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
          // }
          // that.initialSku = {}
          that.i = 1
        }
        // }
      })
      that.showsku = true
    }
  },
  // 糖化测试-规格
  openSku_ndoresult(items, idx, that) {
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec
    that.sku.tree = []
    that.sku.list = []
    that.listItem.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.listItem.sku_rule_list.map(function (item) {
      // if (item.issale === 1 && item.islimit === 0) {
      var stockNum =
        parseInt(item.issale) === 1 && parseInt(item.islimit) === 0 && item.is_can_buy != 0
          ? parseInt(item.canbuycnt)
          : 0
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        stock_num: stockNum
      })
      if (!that.initialSku.id && item.skuid === that.listItem.skuid) {
        let initialSku = {
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: items.num
        }
        that.initialSku = initialSku
      }
      // }
    })
    // console.log('sku.list', that.sku.list)
    // console.log('initialSku', that.initialSku)
    that.showsku = true
  },
  // 新品试用-规格
  openSku_newproductdetail(that) {
    that.productId = that.info.iteminfo.itemid
    that.maxNum = 1
    that.goods.title = that.info.iteminfo.name
    that.goods.picture = that.info.iteminfo.img_main_path
    that.skuname = ''
    that.sku.tree = []
    that.sku.list = []
    that.info.iteminfo.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.info.iteminfo.sku_rule_list.map(function (item, index) {
      var stockNum =
        item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 ? 0 : parseInt(item.canbuycnt)
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        selectedNum: parseInt(item.num || 1),
        stock_num: stockNum,
        islimit: item.islimit,
        issale: item.issale,
        cost_price: item.cost_price,
        temp_sales_price: parseFloat(item.sales_price).toFixed(2)
      })
      if (stockNum > 0 && that.i == 0) {
        that.initialSku = {
          id: item.skuid,
          price: parseFloat(item.sales_price).toFixed(2),
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: 1,
          stock_num: stockNum,
          islimit: item.islimit,
          issale: item.issale,
          cost_price: item.cost_price,
          temp_sales_price: parseFloat(item.sales_price).toFixed(2)
        }
        that.i = 1
      }
    })
    that.showsku = true
  },
  // 收单宝-规格
  openSku_recommendProducts(index, item, that) {
    if (item.inventory != 1) {
      return
    }
    that.productNum = item.num
    that.listItem = item
    that.itemIndex = index
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = item.name
    that.skuprice = parseFloat(item.sales_price).toFixed(2)
    that.goods.picture = item.img_path
    that.skuname = item.spec
    that.sku.tree = []
    that.sku.list = []

    that.listItem.normlist.map(function (item, index) {
      that.sku.tree.push({
        k: item.spec_classify_name,
        v: [],
        k_s: 's' + (index + 1)
      })
      item.speclist.map(function (itemSon) {
        that.sku.tree[index].v.push({
          id: itemSon.spec_id,
          name: itemSon.spec_name
        })
      })
    })
    that.listItem.sku_rule_list.map(function (item) {
      var stockNum =
        item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0
          ? 0
          : parseInt(item.canbuycnt)
      that.sku.list.push({
        id: item.skuid,
        price: parseFloat(item.sales_price).toFixed(2),
        s1: item.spec_group_id.split('_')[0],
        s2: item.spec_group_id.split('_')[1],
        s3: item.spec_group_id.split('_')[2],
        stock_num: stockNum,
        islimit: item.islimit,
        issale: item.issale,
        cost_price: item.cost_price,
        temp_sales_price: parseFloat(item.sales_price).toFixed(2)
      })
      if (item.skuid == that.listItem.skuid) {
        that.initialSku = {
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          selectedNum: parseInt(item.num),
          cost_price: item.cost_price,
          temp_sales_price: parseFloat(item.sales_price).toFixed(2)
        }
      }
    })
    that.showsku = true
  },
  // 浏览足迹-规格
  openSku_footprint(items, idx, that) {
    that.daiIndex = 0
    that.zcIndex = 0
    items.sku_rule_list.map(function (item) {
      if (item.issale == 1 && item.canbuycnt > 0) {
        if (item.islimit == 1) {
          // 待售
          that.daiIndex++
        } else if (item.islimit == 0) {
          that.zcIndex++
        }
      }
    })
    if (that.zcIndex <= 0 && that.daiIndex <= 0) {
      that.$toast('当前商品无货')
      return
    }
    that.productNum = items.num
    that.listItem = items
    that.itemIndex = idx
    that.productId = that.listItem.itemid
    that.maxNum = parseInt(that.listItem.canbuycnt)
    that.goods.title = items.name
    that.skuprice = parseFloat(items.sales_price).toFixed(2)
    that.skucostprice = parseFloat(items.cost_price).toFixed(2)
    that.goods.picture = items.img_path
    that.skuname = items.spec ? items.spec : ''
    // console.log('skuValueToast:', that.skuValueToast)
    if (
      !that.skuValueToast ||
      !that.skuValueToast.selectedSkuComb ||
      that.skuValueToast.selectedSkuComb.stock_num <= 0
    ) {
      that.goods.picture = items.img_path
      that.skuname = ''
      that.sureGray = true
      that.i = 0
    }
    var arg = isApp()
    if (!isWeixin()) {
      if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists && arg == '') {
        that.$store.commit('PATH_VALUE', JSON.stringify({ itemid: that.$route.query.itemid }))
        that.$router.push({
          path: '/login',
          query: {
            routeval: 'productdetail'
          }
        })
      } else {
        that.sku.list = []
        that.sku.tree = []
        items.normlist.map(function (item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function (itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function (item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum =
            item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
              ? 0
              : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum,
            cost_price: item.cost_price
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
          }
          // }
        })
        // console.log('that.skuprice:', that.skuprice)
        that.showsku = true
      }
    } else {
      that.sku.tree = []
      that.sku.list = []
      items.normlist.map(function (item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function (itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      items.sku_rule_list.map(function (item) {
        // if (item.issale === 1 && item.islimit === 0) {
        var stockNum = item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: item.sales_price,
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          payfreight: item.freightrule.payfreight,
          isdiscount: item.isdiscount,
          isfullgift: item.isfullgift,
          ispresale: item.ispresale,
          presaletime: item.presaletime,
          stock_num: stockNum,
          cost_price: item.cost_price
        })
        if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
          if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
            that.skuValueToast.selectedSkuComb.stock_num = stockNum
            if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
              that.goods.picture = items.img_main_path
              that.skuname = ''
              that.sureGray = true
            }
          }
        }
        that.sku.stock_num += stockNum
        if (stockNum > 0 && that.i == 0) {
          that.skuname = item.sku_name
          that.goods.picture = item.spec_imgpath
          that.goods.isdiscount = item.isdiscount
          that.goods.isfullgift = item.isfullgift
          that.goods.payfreight = item.freightrule.payfreight
          that.goods.ispresale = item.ispresale
          that.goods.presaletime = item.presaletime
          that.initialSku = {
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            selectedNum: 1
          }
          that.i = 1
        } else if (stockNum <= 0 && that.i == 0) {
          that.skuprice = parseFloat(items.sales_price).toFixed(2)
          that.skucostprice = parseFloat(items.cost_price).toFixed(2)
          // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
          // } else {
          //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
          // }
          // that.initialSku = {}
          that.i = 1
        }
        // }
      })
      that.showsku = true
    }
  },
  // 商品详情-规格
  openSku_productdetail(type, that) {
    var arg = isApp()
    if (
      !that.skuValueToast ||
      !that.skuValueToast.selectedSkuComb ||
      that.skuValueToast.selectedSkuComb.stock_num <= 0
    ) {
      that.goods.picture = that.productDateils.img_main_path
      that.skuname = ''
      that.sureGray = true
      that.i = 0
    }
    if (!isWeixin() && arg == '') {
      if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
        that.$store.commit('PATH_VALUE', JSON.stringify(that.$route.query))
        that.$router.push({
          path: '/login',
          query: {
            routeval: 'productdetail'
          }
        })
      } else {
        if (that.zcIndex <= 0 && that.daiIndex <= 0 && type == 0) {
          return
        }
        Func(0)
      }
    } else {
      if (that.zcIndex <= 0 && that.daiIndex <= 0 && type == 0) {
        return
      }
      Func(1)
    }

    function Func(typef) {
      if (type == 1) {
        if (
          that.changebuytype &&
          (that.defectivegood == 1 || that.nocartshow == 1) &&
          that.$route.query.isbuy == 0
        ) {
          return
        }
        if (that.zcIndex > 0) {
        } else {
          if (that.pushmsgId.length && that.wuIndex > 0 && that.daiIndex <= 0) {
            // that.AOGRemind()
          } else if (
            (that.wuIndex > 0 && that.daiIndex <= 0) ||
            (that.daiIndex > 0 && that.wuIndex <= 0)
          ) {
            return
          }
        }
        if (that.depositObj.isdeposit == 1 && that.depositObj.actstatus != 1) {
          that.payDeposit()
          return
        }
        if (
          !(
            that.zcIndex > 0 ||
            (that.daiIndex > 0 && that.updatesaleendtime) ||
            (that.wuIndex > 0 && that.subscribeShow != 0)
          )
        ) {
          return
        }
      }
      that.sku.list = []
      that.buyType = type
      that.productDateils.sku_rule_list.map(function (item, index) {
        var stockNum
        if (type == 1) {
          stockNum =
            item.issale == 0 ||
            (item.autochangetime <= 0 && item.islimit == 1) ||
            (item.islimit == 2 && item.subscribeShow == 0) ||
            (typef != 1 && item.is_can_buy == 0)
              ? 0
              : parseInt(item.canbuycnt)
        } else {
          stockNum =
            item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
              ? 0
              : parseInt(item.canbuycnt)
        }

        that.sku.list.push({
          ...item,
          id: item.skuid,
          price: item.sales_price,
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          payfreight: item.freightrule.payfreight,
          pushmsgId: item.pushmsgId ? item.pushmsgId : '',
          stock_num: stockNum
        })
        if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
          if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
            that.skuValueToast.selectedSkuComb.stock_num = stockNum
            if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
              that.goods.picture = that.productDateils.img_main_path
              that.skuname = ''
              that.sureGray = true
            }
            if (item.islimit == 1) {
              that.updatesaletimeitem =
                item.surpluschangetime > 0 ? item.surpluschangetime * 1000 : 0
              that.updatesaleendtimeitem =
                item.autochangetime > 0 ? dateFn(item.autochangetime * 1000, 'datetimestr', 1) : ''
            } else if (item.islimit == 2 && item.subscribeShow != 0) {
              that.subscribeShowitem = item.subscribeShow
            }
          }
        }
        that.sku.stock_num += stockNum
        if (stockNum > 0 && that.i == 0) {
          that.skuname = item.sku_name
          that.goods.picture = item.spec_imgpath
          that.goods.isdiscount = item.isdiscount
          that.goods.isfullgift = item.isfullgift
          that.goods.payfreight = item.freightrule.payfreight
          that.goods.ispresale = item.ispresale
          that.goods.presaletime = item.presaletime
          that.goods.subScribeTime = item.subScribeTime
          that.limitinfo = item.limitinfo ? item.limitinfo : ''
          that.initialSku = {
            ...item,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            pushmsgId: item.pushmsgId ? item.pushmsgId : '',
            selectedNum: 1
          }
          that.unitPriceHandle({
            price: item.sales_price,
            costPrice: item.cost_price,
            actLabel: item.actLabel || '',
            actType: item.actType || 0,
            item
          })
          that.goodsCountDownFn({ item })
          that.i = 1
        }
      })
      if (
        that.changebuytype &&
        that.defectivegood == 1 &&
        that.$route.query.isbuy != 0 &&
        type == 1
      ) {
        that.onConfirmClicked()
      } else {
        that.showsku = true
      }
    }
  },
  /**************************************************/
  //购物车-规格&分组列表·特殊购物车-规格
  checkedSku_cart(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            that.skucostprice = parseFloat(skuValue.selectedSkuComb.cost_price).toFixed(2)
          }
          break
        }
      }
    }
  },
  //店铺福利-规格
  checkedSku_compro(skuValue, that) {
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] !== '') {
        skuStr =
          skuStr === '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index === skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id === skuStr) {
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    } else {
      that.skuprice =
        parseFloat(that.listItem.sales_low_price).toFixed(2) +
        '-' +
        parseFloat(that.listItem.sales_high_price).toFixed(2)
    }
  },
  //商品组件productItem.vue-规格
  checkedSku_proitem(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    that.skuValueToast = skuValue
    console.log(skuValue.selectedSkuComb)
    if (skuValue.selectedSkuComb) {
      that.customStepperConfig.stockNum = that.quota = skuValue.selectedSkuComb.stock_num
    } else {
      that.customStepperConfig.stockNum = that.quota = 0
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    that.goods.isdiscount = 0
    that.goods.isfullgift = 0
    that.goods.payfreight = 0
    that.goods.ispresale = 0
    that.goods.presaletime = ''
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          that.goods.isdiscount = len[i].isdiscount
          that.goods.isfullgift = len[i].isfullgift
          that.goods.payfreight = len[i].freightrule.payfreight
          that.goods.ispresale = len[i].ispresale
          that.goods.presaletime = len[i].presaletime
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            that.skucostprice = parseFloat(skuValue.selectedSkuComb.cost_price).toFixed(2)
          }
          break
        }
      }
    }
  },
  //函金靓-精选好物-规格
  checkedSku_bspl(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    } else {
      if (that.listItem.sales_low_price != that.listItem.sales_high_price) {
        that.skuprice =
          parseFloat(that.listItem.sales_low_price).toFixed(2) +
          '-' +
          parseFloat(that.listItem.sales_high_price).toFixed(2)
      } else {
        that.skuprice = parseFloat(that.listItem.sales_low_price).toFixed(2)
      }
    }
  },
  //领券-可用商品-规格
  checkedSku_couponproduct(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    }
  },
  //畅销榜-规格
  checkedSku_bestsell(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    that.skuValueToast = skuValue
    if (skuValue.selectedSkuComb) {
      that.customStepperConfig.stockNum = that.quota = skuValue.selectedSkuComb.stock_num
    } else {
      that.customStepperConfig.stockNum = that.quota = 0
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    that.goods.isdiscount = 0
    that.goods.isfullgift = 0
    that.goods.payfreight = 0
    that.goods.ispresale = 0
    that.goods.presaletime = ''
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          that.goods.isdiscount = len[i].isdiscount
          that.goods.isfullgift = len[i].isfullgift
          that.goods.payfreight = len[i].freightrule.payfreight
          that.goods.ispresale = len[i].ispresale
          that.goods.presaletime = len[i].presaletime
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    } else {
      that.skuprice = parseFloat(that.listItem.sales_price).toFixed(2)
      // if (that.listItem.sales_low_price != that.listItem.sales_high_price) {
      //   that.skuprice = parseFloat(that.listItem.sales_low_price).toFixed(2) + '-' + parseFloat(that.listItem.sales_high_price).toFixed(2)
      // } else {
      //   that.skuprice = parseFloat(that.listItem.sales_low_price).toFixed(2)
      // }
    }
    console.log(skuValue, 'that.initialSku', that.initialSku)
  },
  // 糖化测试-规格
  checkedSku_ndoresult(skuValue, that) {
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] !== '') {
        skuStr =
          skuStr === '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index === skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id === skuStr) {
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    } else {
      that.skuprice =
        parseFloat(that.listItem.sales_low_price).toFixed(2) +
        '-' +
        parseFloat(that.listItem.sales_high_price).toFixed(2)
    }
  },
  // 新品试用-规格
  checkedSku_newproductdetail(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.info.iteminfo.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          break
        }
      }
    }
  },
  // 收单宝-规格
  checkedSku_recommendProducts(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
          }
          break
        }
      }
    }
  },
  // 浏览足迹-规格
  checkedSku_footprint(skuValue, that) {
    if (!skuValue.selectedSkuComb) {
      that.sureGray = true
    } else {
      that.sureGray = false
    }
    that.skuValueToast = skuValue
    console.log(skuValue.selectedSkuComb)
    if (skuValue.selectedSkuComb) {
      that.customStepperConfig.stockNum = that.quota = skuValue.selectedSkuComb.stock_num
    } else {
      that.customStepperConfig.stockNum = that.quota = 0
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.listItem.sku_rule_list
    var skuIndex = 0
    var index = 0
    that.goods.isdiscount = 0
    that.goods.isfullgift = 0
    that.goods.payfreight = 0
    that.goods.ispresale = 0
    that.goods.presaletime = ''
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] != '') {
        skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index == skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id == skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          that.goods.isdiscount = len[i].isdiscount
          that.goods.isfullgift = len[i].isfullgift
          that.goods.payfreight = len[i].freightrule.payfreight
          that.goods.ispresale = len[i].ispresale
          that.goods.presaletime = len[i].presaletime
          if (skuValue.selectedSkuComb !== null) {
            that.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            that.skucostprice = parseFloat(skuValue.selectedSkuComb.cost_price).toFixed(2)
          }
          break
        }
      }
    }
  },
  // 商品详情-规格
  checkedSku_productdetail(skuValue, that) {
    console.log(skuValue)
    if (skuValue.selectedSkuComb != null) {
      that.sureGray = false
      if (that.depositObj.isdeposit) {
        that.depositObj.totalPrice = that.depositObj.depositmoney
      }
    } else {
      that.sureGray = true
    }

    that.skuValueToast = skuValue
    if (skuValue.selectedSkuComb) {
      that.unitPriceHandle({
        price: skuValue.selectedSkuComb.price,
        costPrice: skuValue.selectedSkuComb.cost_price,
        actLabel: skuValue.selectedSkuComb.actLabel || '',
        actType: skuValue.selectedSkuComb.actType || 0,
        item: skuValue.selectedSkuComb
      })
      that.goodsCountDownFn({ item: skuValue.selectedSkuComb })
      that.customStepperConfig.stockNum = that.quota = skuValue.selectedSkuComb.stock_num
    } else {
      that.customStepperConfig.stockNum = that.quota = 0
    }
    var skuStr = ''
    that.skuname = ''
    var len = that.productDateils.sku_rule_list
    var skuIndex = 0
    var index = 0
    that.goods.isdiscount = 0
    that.goods.isfullgift = 0
    that.goods.payfreight = 0
    that.goods.ispresale = 0
    that.goods.presaletime = ''
    that.goods.subScribeTime = ''
    that.updatesaletimeitem = 0
    that.updatesaleendtimeitem = ''
    that.subscribeShowitem = 0
    Object.keys(skuValue.selectedSku).forEach(function (key) {
      skuIndex++
      if (skuValue.selectedSku[key] !== '') {
        skuStr =
          skuStr === '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
        index++
      }
    })
    if (index === skuIndex) {
      for (var i = 0; i < len.length; i++) {
        if (len[i].spec_group_id === skuStr) {
          that.selectedSkuIndex = i
          that.skuname = len[i].sku_name
          that.goods.picture = len[i].spec_imgpath
          that.goods.isdiscount = len[i].isdiscount
          that.goods.isfullgift = len[i].isfullgift
          that.goods.payfreight = len[i].freightrule.payfreight
          that.goods.ispresale = len[i].ispresale
          that.goods.presaletime = len[i].presaletime
          that.goods.subScribeTime = len[i].subScribeTime
          that.limitinfo = len[i].limitinfo ? len[i].limitinfo : ''
          if (len[i].islimit == 1) {
            that.updatesaletimeitem =
              len[i].surpluschangetime > 0 ? len[i].surpluschangetime * 1000 : 0
            that.updatesaleendtimeitem =
              len[i].autochangetime > 0
                ? dateFn(len[i].autochangetime * 1000, 'datetimestr', 1)
                : ''
          } else if (len[i].islimit == 2 && len[i].subscribeShow != 0) {
            that.subscribeShowitem = len[i].subscribeShow
          }
          if (skuValue.selectedSkuComb != null) {
            that.skuprice = (
              parseFloat(skuValue.selectedSkuComb.price) +
              parseFloat(that.directReduction.directReductionPrice)
            ).toFixed(2)
          }
          if (skuValue.selectedSkuComb != null) {
            that.skucostprice = parseFloat(skuValue.selectedSkuComb.cost_price).toFixed(2)
          }
          break
        }
      }
    }
  },
  /**************************************************/
  //购物车-规格-确定&分组列表·特殊购物车-规格-确定
  onConfirmClicked_cart(that, { actgroupid = '' } = {}) {
    var skuData = that.$refs.sku.getSkuData()
    if (!skuData.selectedSkuComb) {
      return
    }
    var datas = {
      skuid: that.listItem.skuid,
      num: that.productNum,
      new_skuid: skuData.selectedSkuComb.id
    }
    if (actgroupid) {
      datas = {
        skuids: that.listItem.skuid,
        nums: that.productNum,
        new_skuids: skuData.selectedSkuComb.id,
        actgroupid
      }
      if (sessionStorage.getItem('ck_utoken')) {
        datas.ck_utoken = sessionStorage.getItem('ck_utoken')
      }
    }
    if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
      that.updateProduct(datas, function () {
        that.$nextTick(function () {
          that.initialSku = skuData.selectedSkuComb
          that.initialSku['selectedNum'] = skuData.selectedNum
        })
        that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
        that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        that.list[that.itemIndex].spec = that.skuname
        that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
        that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
        that.list[that.itemIndex].price = skuData.selectedSkuComb.original_price
        that.list[that.itemIndex].cost_price = skuData.selectedSkuComb.cost_price
        that.list[that.itemIndex].temp_sales_price = skuData.selectedSkuComb.temp_sales_price
        that.list[that.itemIndex].ismorediscounts = skuData.selectedSkuComb.ismorediscounts
        that.list[that.itemIndex].morediscountslabel = skuData.selectedSkuComb.morediscountslabel
        that.list[that.itemIndex].morediscountsmoney = skuData.selectedSkuComb.morediscountsmoney
        that.list[that.itemIndex].morediscountsitemnum =
          skuData.selectedSkuComb.morediscountsitemnum
        that.list[that.itemIndex].issuperposition = skuData.selectedSkuComb.issuperposition
        that.list[that.itemIndex].morediscountdesc = skuData.selectedSkuComb.morediscountdesc
        that.list[that.itemIndex].morediscountsname = skuData.selectedSkuComb.morediscountsname

        if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
          that.productNum = skuData.selectedSkuComb.stock_num
        }
        that.list[that.itemIndex].num = that.productNum
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        if (
          that.list[that.itemIndex].islimit != 0 ||
          parseInt(that.list[that.itemIndex].canbuycnt) <= 0 ||
          that.list[that.itemIndex].issale == 0 ||
          that.list[that.itemIndex].is_can_buy == 0
        ) {
          that.list[that.itemIndex].ischoose = 0
        } else {
          if (that['fullDiscountRuleFn']) that.fullDiscountRuleFn()
          if (that['birthdayDiscountRuleFn']) that.birthdayDiscountRuleFn()
          that.totalMoney()
        }
      })
    }
    // console.log('that.list', that.list)
    that.showsku = false
  },
  //店铺福利-规格-确定
  onConfirmClicked_compro(that) {
    var skuData = that.$refs.sku.getSkuData()
    let resultlist = []
    console.log(skuData.selectedSkuComb)
    if (!skuData.selectedSkuComb) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      that.resultlist.forEach(function (item, index) {
        if (item === that.listItem.skuid) {
          item = skuData.selectedSkuComb.id
        }
        resultlist.push(item)
      })
      that.resultlist = resultlist
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.$nextTick(function () {
          that.initialSku = skuData.selectedSkuComb
          that.initialSku['selectedNum'] = skuData.selectedNum
        })
        that.info.itemlist[that.itemIndex].islimit = skuData.selectedSkuComb.stock_num > 0 ? 0 : 1
        that.info.itemlist[that.itemIndex].spec = that.skuname
        // that.info.itemlist[that.itemIndex].num = skuData.selectedNum
        that.info.itemlist[that.itemIndex].sales_price = skuData.selectedSkuComb.price
        that.info.itemlist[that.itemIndex].skuid = skuData.selectedSkuComb.id
      }
      that.showsku = false
    }
  },
  //商品组件productItem.vue-规格-立即购买/加入购物车
  onConfirmClicked_proitem(type, that) {
    that.buyType = type
    if (that.sureGray) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      // 1立即购买，0加入购物车
      let dataType = that.buyType == 1 ? 'buyNow' : 'addToCart'
      that.dataCollection(dataType)
      var skuData = that.$refs.sku.getSkuData()
      if (skuData.selectedSkuComb !== null) {
        that.showsku = false
        that.$refs.skuPreview.hidePreview()
        that.skuId = skuData.selectedSkuComb.id
        if (skuData.selectedNum == 0) {
          skuData.selectedNum = 1
        }
        that.itemnum = skuData.selectedNum
        var urlCheck =
          that.$ajax.checkOrder_URL + '?skuids=' + that.skuId + '&buynum=' + that.itemnum
        var urlShop = that.$ajax.addShoppingCart_URL
        if (that.query.actgroupid && that.params.isShowCart == 1) {
          urlShop = that.$ajax.addItemCart_URL
        }
        var data = {
          skuid: that.skuId,
          itemnum: that.itemnum
        }
        if (that.query.actgroupid && that.params.isShowCart == 1) {
          data = {
            ...data,
            skuids: that.skuId,
            nums: that.itemnum,
            actgroupid: that.query.actgroupid
          }
          if (sessionStorage.getItem('ck_utoken')) {
            data.ck_utoken = sessionStorage.getItem('ck_utoken')
          }
        }
        if (!that.buyType) {
          that.$customRequestAjax.post(urlShop, data).then((res) => {
            if (res.data.code === 200) {
              if (!that.query.actgroupid || !that.params.isShowCart == 1) {
                that.$store.commit('ADD_CART_INIT_DATA', 1)
                that.$commonburiedPoint({
                  data: {
                    isaddcart: 1,
                    itemid: that.skuId,
                    skuid: that.skuId
                  }
                })
                if (that.$route.path == '/cart') {
                  that.$emit('addCartHandler')
                }
                that.$toast('已成功加入购物车')
              } else if (that.query.actgroupid && that.params.isShowCart == 1) {
                let selectedGoodsresult = []
                if (localStorage.getItem('selectedGoodsresult_' + that.params.payMethods)) {
                  selectedGoodsresult = JSON.parse(
                    localStorage.getItem('selectedGoodsresult_' + that.params.payMethods)
                  )
                }
                if (!selectedGoodsresult.some((item) => item == that.skuId)) {
                  selectedGoodsresult.unshift(that.skuId)
                }
                localStorage.setItem(
                  'selectedGoodsresult_' + that.params.payMethods,
                  JSON.stringify(selectedGoodsresult)
                )
                that.$toast('已成功加入购物袋')
              }
            }
          })
        } else {
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code === 200) {
              if (res.data.vipLevelLimitMsg) {
                that.$dialog
                  .confirm({
                    message: res.data.vipLevelLimitMsg,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去查看'
                  })
                  .then(() => {
                    // on close
                    that.$app.argLink({ path: '/vipcenter' })
                  })
                return
              }
              let currentdiscount =
                skuData.selectedSkuComb.isdiscount == 1 ? that.currentdiscount : 1
              var shopConfirmResult = {
                skuidArr: [],
                from: 2,
                orderfrom: 1,
                liveId: that.prolistItem.liveid ? [that.prolistItem.liveid] : [],
                itemNum: [],
                totalmoney:
                  parseFloat(skuData.selectedSkuComb.price) * skuData.selectedNum * currentdiscount,
                totalnum: skuData.selectedNum,
                actgroupid: that.query.actgroupid || '' //分组列表id
              }
              shopConfirmResult.skuidArr.push(that.skuId)
              shopConfirmResult.itemNum.push(that.itemnum)
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              if (that.query.actgroupid && that.params.payMethods == 2) {
                that.$app.argFunc(
                  () => {
                    that.$router.push('/order?yl=1&acttype=hc_welfare_private')
                  },
                  () => {
                    that.$dialog
                      .alert({
                        title: '温馨提示',
                        message: '当前系统不支持该链接查询，请关注"创客村"公众号查看详情',
                        confirmButtonText: '我知道了',
                        className: 'percen_button_alert',
                        confirmButtonColor: '#FFFCFC',
                        closeOnPopstate: true
                      })
                      .then(() => {})
                  },
                  () => {
                    that.$dialog
                      .alert({
                        title: '温馨提示',
                        message: '当前系统不支持该链接查询，请关注"创客村"公众号查看详情',
                        confirmButtonText: '我知道了',
                        className: 'percen_button_alert',
                        confirmButtonColor: '#FFFCFC',
                        closeOnPopstate: true
                      })
                      .then(() => {})
                  }
                )
              } else {
                that.$app.argFunc(
                  () => {
                    that.$router.push('/order')
                  },
                  () => {
                    shopConfirmResult.orderHadOnShow = 0
                    shopConfirmResult.isInitData = 1
                    shopConfirmResult.live_id = ''
                    shopConfirmResult.type = 'addToConfirmOrder'
                    wx.miniProgram.navigateTo({
                      url:
                        '/pages/order/main?shopConfirmResult=' +
                        JSON.stringify(shopConfirmResult) +
                        '&scenepoint=' +
                        encodeURIComponent(window.document.title) +
                        '&exclusiveid=' +
                        exclusiveidFn() +
                        pointParams('&')
                    })
                  },
                  () => {
                    var obj = {
                      type: 'addToConfirmOrder',
                      skuids: shopConfirmResult.skuidArr.join(),
                      item_num: shopConfirmResult.itemNum.join(),
                      from: shopConfirmResult.from
                    }
                    that.$commonburiedPoint({
                      data: {
                        scenepoint: window.document.title,
                        scenedesc: window.location.href,
                        url: 'order-confirm'
                      },
                      rnType: 'addToConfirmOrder',
                      callback: () => {
                        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                      }
                    })
                  }
                )
              }
            }
          })
        }
      }
    }
  },
  //函金靓-精选好物-规格-确定
  onConfirmClicked_bspl(that) {
    let skuData = that.$refs.sku.getSkuData(),
      datas

    if (!skuData.selectedSkuComb) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      datas = {
        skuid: that.listItem.skuid,
        num: that.productNum,
        new_skuid: skuData.selectedSkuComb.id
      }
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.updateProduct(datas, function () {
          that.$nextTick(function () {
            that.initialSku = skuData.selectedSkuComb
            that.initialSku['selectedNum'] = skuData.selectedNum
          })
          that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
          that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          that.list[that.itemIndex].spec = that.skuname
          that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
          that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
          that.list[that.itemIndex].temp_sales_price = skuData.selectedSkuComb.temp_sales_price
          that.list[that.itemIndex].changebuystatus = skuData.selectedSkuComb.changebuystatus
          if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
            that.productNum = skuData.selectedSkuComb.stock_num
          }
          that.list[that.itemIndex].num = that.productNum
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          if (
            that.list[that.itemIndex].islimit != 0 ||
            parseInt(that.list[that.itemIndex].canbuycnt) <= 0 ||
            that.list[that.itemIndex].issale == 0
          ) {
            that.list[that.itemIndex].ischoose = 0
          } else {
            that.count()
          }
        })
      }
      that.showsku = false
    }
  },
  //领券-可用商品-规格-确定
  onConfirmClicked_couponproduct(that) {
    var skuData = that.$refs.sku.getSkuData()
    if (!skuData.selectedSkuComb) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.$nextTick(function () {
          that.initialSku = skuData.selectedSkuComb
          that.initialSku['selectedNum'] = skuData.selectedNum
        })
        that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
        that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        that.list[that.itemIndex].spec = that.skuname
        that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
        that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
        that.list[that.itemIndex].changebuystatus = skuData.selectedSkuComb.changebuystatus
        if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
          that.productNum = skuData.selectedSkuComb.stock_num
        }
        that.list[that.itemIndex].num = that.productNum
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        that.choosed('update')
      }
      console.log('initialSku', that.initialSku)
      that.showsku = false
    }
  },
  //畅销榜-规格-确定
  onConfirmClicked_bestsell(that) {
    if (that.sureGray) {
      return
    }

    // 1立即购买，0加入购物车
    that.dataCollection()
    var skuData = that.$refs.sku.getSkuData()
    if (skuData.selectedSkuComb !== null) {
      that.showsku = false
      that.skuId = skuData.selectedSkuComb.id
      if (skuData.selectedNum == 0) {
        skuData.selectedNum = 1
      }
      that.itemnum = skuData.selectedNum
      var urlShop = that.$ajax.addShoppingCart_URL
      var data = {
        skuid: that.skuId,
        itemnum: that.itemnum
      }

      if (that.$route.query.shareOpenid && that.$route.query.shareOpenid != appid) {
        data.shareOpenid = that.$route.query.shareOpenid
      }
      console.log('appid', appid)
      console.log('shareOpenid', that.$route.query.shareOpenid)
      console.log(data)
      that.$customRequestAjax.post(urlShop, data).then((res) => {
        if (res.data.code === 200) {
          that.$store.commit('ADD_CART_INIT_DATA', 1)
          that.$toast('已成功加入购物车')
          that.cartNum()
        }
      })
    }
  },
  // 糖化测试-规格-确定
  onConfirmClicked_ndoresult(that) {
    var skuData = that.$refs.sku.getSkuData()
    let resultlist = []
    that.resultlist.forEach(function (item, index) {
      if (item === that.listItem.skuid) {
        item = skuData.selectedSkuComb.id
      }
      resultlist.push(item)
    })
    that.resultlist = resultlist
    if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
      that.$nextTick(function () {
        that.initialSku = skuData.selectedSkuComb
        that.initialSku['selectedNum'] = skuData.selectedNum
      })
      that.info.itemlist[that.itemIndex].islimit = skuData.selectedSkuComb.stock_num > 0 ? 0 : 1
      that.info.itemlist[that.itemIndex].spec = that.skuname
      // that.info.itemlist[that.itemIndex].num = skuData.selectedNum
      that.info.itemlist[that.itemIndex].skuid = skuData.selectedSkuComb.id
    }
    that.showsku = false
  },
  // 新品试用-规格-确定
  onConfirmClicked_newproductdetail(that) {
    var skuData = that.$refs.sku.getSkuData(),
      skuid = ''
    if (skuData.selectedSkuComb !== null) {
      that.showsku = false
      skuid = skuData.selectedSkuComb.id
      const url = that.$ajax.addApplyNoReason_URL
      let paramsData = {
        actid: that.$route.query.id,
        skuid: skuid
      }
      that.$customRequestAjax.post(url, paramsData).then((res) => {
        if (res.data.code == 200) {
          that.info.applyStatus = 2
          that.info.applySkuid = skuid
          that.$dialog
            .confirm({
              title: '恭喜您申请成功',
              message: res.data.msg,
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '补充信息',
              cancelButtonText: '转发助力'
            })
            .then(() => {
              // on confirm
              const query = {
                actid: that.$route.query.id,
                skuid: that.info.applySkuid,
                integral: that.info.point
              }
              that.$router.push({
                path: '/applytrial',
                query
              })
            })
            .catch(() => {
              // on cancel
              that.isshare = true
            })
        }
      })
    }
  },
  // 收单宝-规格-确定
  onConfirmClicked_recommendProducts(that) {
    let skuData = that.$refs.sku.getSkuData(),
      datas

    if (!skuData.selectedSkuComb) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      datas = {
        skuid: that.listItem.skuid,
        num: that.productNum,
        new_skuid: skuData.selectedSkuComb.id
      }
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.updateProduct(datas, function () {
          that.$nextTick(function () {
            that.initialSku = skuData.selectedSkuComb
            that.initialSku['selectedNum'] = skuData.selectedNum
          })
          that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
          that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          that.list[that.itemIndex].spec = that.skuname
          that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
          that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
          that.list[that.itemIndex].temp_sales_price = skuData.selectedSkuComb.temp_sales_price
          that.list[that.itemIndex].changebuystatus = skuData.selectedSkuComb.changebuystatus
          if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
            that.productNum = skuData.selectedSkuComb.stock_num
          }
          that.list[that.itemIndex].num = that.productNum
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          if (
            that.list[that.itemIndex].islimit != 0 ||
            parseInt(that.list[that.itemIndex].canbuycnt) <= 0 ||
            that.list[that.itemIndex].issale == 0
          ) {
            that.list[that.itemIndex].ischoose = 0
          } else {
            that.count()
          }
        })
      }
      that.showsku = false
    }
  },
  // 浏览足迹-规格-立即购买/加入购物车
  onConfirmClicked_footprint(type, that) {
    that.buyType = type
    if (that.sureGray) {
      return
    }
    this.goodsbuytips(that.listItem, that, () => {
      func()
    })
    function func() {
      // 1立即购买，0加入购物车
      let dataType = that.buyType == 1 ? 'buyNow' : 'addToCart'
      that.dataCollection(dataType)
      var skuData = that.$refs.sku.getSkuData()
      if (skuData.selectedSkuComb !== null) {
        that.showsku = false
        that.$refs.skuPreview.hidePreview()
        that.skuId = skuData.selectedSkuComb.id
        if (skuData.selectedNum == 0) {
          skuData.selectedNum = 1
        }
        that.itemnum = skuData.selectedNum
        var urlCheck =
          that.$ajax.checkOrder_URL + '?skuids=' + that.skuId + '&buynum=' + that.itemnum
        var urlShop = that.$ajax.addShoppingCart_URL
        var data = {
          skuid: that.skuId,
          itemnum: that.itemnum
        }
        if (!that.buyType) {
          console.log(data)
          that.$customRequestAjax.post(urlShop, data).then((res) => {
            if (res.data.code === 200) {
              that.$store.commit('ADD_CART_INIT_DATA', 1)
              that.$commonburiedPoint({
                data: {
                  isaddcart: 1,
                  itemid: that.skuId,
                  skuid: that.skuId
                }
              })
              that.$toast('已成功加入购物车')
              if (that.$route.path == '/cart') {
                that.$emit('addCartHandler')
              }
            }
          })
        } else {
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code === 200) {
              if (res.data.vipLevelLimitMsg) {
                that.$dialog
                  .confirm({
                    message: res.data.vipLevelLimitMsg,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去查看'
                  })
                  .then(() => {
                    // on close
                    that.$app.argLink({ path: '/vipcenter' })
                  })
                return
              }
              let currentdiscount =
                skuData.selectedSkuComb.isdiscount == 1 ? that.currentdiscount : 1
              var shopConfirmResult = {
                skuidArr: [],
                from: 2,
                orderfrom: 1,
                liveId: that.listItem.liveid ? [that.listItem.liveid] : [],
                itemNum: [],
                totalmoney:
                  parseFloat(skuData.selectedSkuComb.price) * skuData.selectedNum * currentdiscount,
                totalnum: skuData.selectedNum
              }
              shopConfirmResult.skuidArr.push(that.skuId)
              shopConfirmResult.itemNum.push(that.itemnum)
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              var arg = isApp()
              if (arg == '') {
                that.$router.push('/order')
              } else if (arg != '' && arg.indexOf('xcx') < 0) {
                var obj = {
                  type: 'addToConfirmOrder',
                  skuids: shopConfirmResult.skuidArr.join(),
                  item_num: shopConfirmResult.itemNum.join(),
                  from: shopConfirmResult.from
                }
                that.$commonburiedPoint({
                  data: {
                    scenepoint: window.document.title,
                    scenedesc: window.location.href,
                    url: 'order-confirm'
                  },
                  rnType: 'addToConfirmOrder',
                  callback: () => {
                    window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                  }
                })
              } else {
                shopConfirmResult.orderHadOnShow = 0
                shopConfirmResult.isInitData = 1
                shopConfirmResult.live_id = ''
                shopConfirmResult.type = 'addToConfirmOrder'
                wx.miniProgram.navigateTo({
                  url:
                    '/pages/order/main?shopConfirmResult=' +
                    JSON.stringify(shopConfirmResult) +
                    '&scenepoint=' +
                    encodeURIComponent(window.document.title) +
                    '&exclusiveid=' +
                    exclusiveidFn() +
                    pointParams('&')
                })
              }
            }
          })
        }
      }
    }
  },
  // 商品详情-规格-立即购买/加入购物车
  onConfirmClicked_productdetail(that) {
    this.goodsbuytips(that.productDateils, that, () => {
      func()
    })
    function func() {
      var skuData = that.$refs.sku.getSkuData()
      if (that.depositObj.isdeposit == 1) {
        that.payDeposit()
        return
      }
      if (
        that.sureGray &&
        !(that.changebuytype && that.defectivegood == 1 && that.$route.query.isbuy != 0)
      ) {
        return
      }
      // 1立即购买，0加入购物车
      let dataType = that.buyType == 1 ? 'buyNow' : 'addToCart'
      that.dataCollection(dataType)

      if (
        that.showPresale == false &&
        that.goods.ispresale == 1 &&
        !localStorage.getItem('itempresale')
      ) {
        that.showPresale = true
        that.showsku = false
        localStorage.setItem('itempresale', '1')
      } else {
        if (that.changebuytype && that.defectivegood == 1 && that.$route.query.isbuy != 0) {
          skuData = {
            selectedSkuComb: {
              id: that.sku.list[0].id,
              price: that.sku.list[0].price
            },
            selectedNum: 1
          }
        }
        if (skuData.selectedSkuComb !== null) {
          that.showsku = false
          that.$refs.skuPreview.hidePreview()
          that.skuId = skuData.selectedSkuComb.id
          that.pushmsgId = skuData.selectedSkuComb.pushmsgId
            ? [skuData.selectedSkuComb.pushmsgId]
            : []
          that.skuids = [skuData.selectedSkuComb.id]
          if (skuData.selectedNum == 0) {
            skuData.selectedNum = 1
          }
          that.itemnum = skuData.selectedNum
          var urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            that.skuId +
            '&buynum=' +
            that.itemnum +
            '&communityid=' +
            that.communityid
          if (that.changebuytype && that.defectivegood == 1) {
            urlCheck = that.$ajax.checkWxpItem_URL
          }
          var urlShop = that.$ajax.addShoppingCart_URL
          var data = {
            skuid: that.skuId,
            itemnum: that.itemnum
          }

          if (that.$route.query.courseid) data.courseid = that.$route.query.courseid

          if (that.$route.query.shareOpenid && that.$route.query.shareOpenid != appid) {
            data.shareOpenid = that.$route.query.shareOpenid
          }

          if (that.buyType === 0) {
            that.$customRequestAjax.post(urlShop, data).then((res) => {
              if (res.data.code === 200) {
                that.$store.commit('ADD_CART_INIT_DATA', 1)
                that.$commonburiedPoint({
                  data: {
                    isaddcart: 1,
                    itemid: that.skuId,
                    skuid: that.skuId,
                    recitemid: that.recommend == 1 ? that.$route.query.itemid : ''
                  }
                })
                that.$toast('已成功加入购物车')
              }
            })
          } else if (that.buyType === 1) {
            if (that.subscribeShowitem != 0 && that.pushmsgId.length) {
              that.AOGRemind()
              return
            }
            that.$clickburiedPoint({
              data: {
                buttonCode: 'BUY',
                recitemid: that.recommend == 1 ? that.$route.query.itemid : ''
              }
            })
            if (that.isoverseas && isWx != 3) {
              // wap端可支付宝支付海外商品
              download_dialog(that)
              return
            }
            if (that.changebuytype && that.defectivegood == 1) {
              that.$customRequestAjax.post(urlCheck, { skuids: that.skuId }).then((res) => {
                if (res.data.code === 200) {
                  f()
                }
              })
            } else {
              that.$customRequestAjax(urlCheck).then((res) => {
                if (res.data.code === 200) {
                  if (res.data.vipLevelLimitMsg) {
                    that.$dialog
                      .confirm({
                        message: res.data.vipLevelLimitMsg,
                        className: 'collect_button_alert',
                        cancelButtonColor: '#FC0324',
                        cancelButtonText: '取消',
                        confirmButtonColor: '#FFFCFC',
                        confirmButtonText: '去查看'
                      })
                      .then(() => {
                        // on close
                        that.$app.argLink({ path: '/vipcenter' })
                      })
                  } else {
                    f()
                  }
                }
              })
            }
            function f() {
              var shopConfirmResult = {
                skuidArr: [],
                from: 2,
                orderfrom: 1,
                liveId: [that.productDateils.liveid],
                itemNum: [],
                totalmoney: parseFloat(skuData.selectedSkuComb.price) * skuData.selectedNum,
                totalnum: skuData.selectedNum,
                communityid: that.communityid,
                groupbuyid: that.groupbuyid || '',
                beautityitemid: that.$route.query.beautitysaidid,
                actgroupid: that.$route.query.actgroupid || '' //分组列表id
              }
              if (that.$route.query.courseid) {
                shopConfirmResult.course_params = [that.skuId + '_' + that.$route.query.courseid]
                shopConfirmResult.save_course_params = [
                  that.skuId +
                    '_' +
                    that.$route.query.courseid +
                    '_' +
                    that.$route.query.seriesid +
                    '_' +
                    (that.$route.query.beauty == 1 ? 2 : 1)
                ]
                shopConfirmResult.beauty = that.$route.query.beauty == 1 ? 1 : 0
              }
              if (that.$route.query.shareOpenid && that.$route.query.shareOpenid != appid) {
                shopConfirmResult.shareOpenid = that.$route.query.shareOpenid
              }

              if (that.$route.query.recommendId) {
                shopConfirmResult.recommendId = that.$route.query.recommendId
              }

              shopConfirmResult.skuidArr.push(that.skuId)
              shopConfirmResult.itemNum.push(that.itemnum)
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              if (that.changebuytype && that.defectivegood == 1) {
                var arg = isApp()
                if (arg == '') {
                  window.location = '/order?yl=1&defectivegood=1'
                } else if (arg.indexOf('xcx') < 0) {
                  var obj = {
                    type: 'defectivegoodBuy',
                    skuids: shopConfirmResult.skuidArr.join(),
                    item_num: shopConfirmResult.itemNum.join(),
                    from: shopConfirmResult.orderfrom
                  }
                  that.$commonburiedPoint({
                    data: {
                      scenepoint: window.document.title,
                      scenedesc: window.location.href,
                      url: 'order-confirm'
                    },
                    rnType: 'defectivegoodBuy',
                    callback: () => {
                      window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                    }
                  })
                } else {
                  shopConfirmResult.orderHadOnShow = 0
                  shopConfirmResult.isInitData = 1
                  shopConfirmResult.live_id = ''
                  shopConfirmResult.type = 'defectivegoodBuy'
                  wx.miniProgram.navigateTo({
                    url:
                      '/pages/order/main?yl=1&defectivegood=1&shopConfirmResult=' +
                      JSON.stringify(shopConfirmResult) +
                      '&scenepoint=' +
                      encodeURIComponent(window.document.title)
                  })
                }
              } else if (that.productDateils.payMethods == 2) {
                that.$router.push('/order?yl=1&acttype=hc_welfare_private')
              } else {
                if (typeof that.$route.query.metro != 'undefined') {
                  that.$router.push('/order?metro=' + that.$route.query.metro)
                } else if (that.groupbuyid) {
                  that.$router.push('/order?groupbuyid=' + that.groupbuyid)
                } else {
                  that.$router.push('/order')
                }
              }
            }
          }
        }
      }
    }
  },
  /**************************************************/
  //商品购买信息提示-弹窗方法
  goodsbuytips(goods, that, callback) {
    var skuData = that.$refs.sku.getSkuData()
    let rep_sku = {},
      rep_sku_data = {}
    try {
      goods.sku_rule_list.map((item) => {
        if (item.skuid == skuData.selectedSkuComb.id) {
          rep_sku = item.rep_sku || {}
          throw new Error('已找到skuid')
        }
      })
    } catch (e) {}
    try {
      if (Object.keys(rep_sku).length > 0 && rep_sku.skuid) {
        goods.sku_rule_list.map((item) => {
          if (item.skuid == rep_sku.skuid) {
            rep_sku_data = item
            throw new Error('已找到sku')
          }
        })
      }
    } catch (e) {}
    if (Object.keys(rep_sku).length > 0) {
      if (skuData.selectedNum >= rep_sku.num && rep_sku.tips) {
        that.$dialog
          .confirm({
            message: rep_sku.tips,
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnPopstate: true
          })
          .then(function () {
            // on confirm
            that.initialSku = {
              s1: rep_sku_data.spec_group_id.split('_')[0],
              s2: rep_sku_data.spec_group_id.split('_')[1],
              s3: rep_sku_data.spec_group_id.split('_')[2],
              selectedNum: 1,
              pushmsgId: rep_sku_data.pushmsgId || ''
            }
            that.skuname = rep_sku_data.sku_name
            that.goods.picture = rep_sku_data.spec_imgpath
            that.skuprice = parseFloat(rep_sku_data.sales_price).toFixed(2)
            that.skucostprice = parseFloat(rep_sku_data.cost_price).toFixed(2)
            if (rep_sku_data.isdiscount) {
              that.goods.isdiscount = rep_sku_data.isdiscount
              that.initialSku.isdiscount = rep_sku_data.isdiscount
            }
            if (rep_sku_data.isfullgift) {
              that.goods.isfullgift = rep_sku_data.isfullgift
              that.initialSku.isfullgift = rep_sku_data.isfullgift
            }
            if (rep_sku_data.freightrule) {
              that.goods.payfreight = rep_sku_data.freightrule.payfreight || 0
              that.initialSku.payfreight = rep_sku_data.freightrule.payfreight || 0
            }
            if (rep_sku_data.ispresale) {
              that.goods.ispresale = rep_sku_data.ispresale
              that.initialSku.ispresale = rep_sku_data.ispresale
            }
            if (rep_sku_data.presaletime) {
              that.goods.presaletime = rep_sku_data.presaletime
              that.initialSku.presaletime = rep_sku_data.presaletime
            }
            if (rep_sku_data.subScribeTime) {
              that.goods.subScribeTime = rep_sku_data.subScribeTime
              that.initialSku.subScribeTime = rep_sku_data.subScribeTime
            }
            if (rep_sku_data.limitinfo) {
              that.limitinfo = rep_sku_data.limitinfo
            }
            if (rep_sku_data.pushmsgId) {
              that.initialSku.pushmsgId = rep_sku_data.pushmsgId
            }
            if (rep_sku_data.sales_price) {
              that.initialSku.temp_sales_price = parseFloat(rep_sku_data.sales_price).toFixed(2)
            }
            if (rep_sku_data.cost_price) {
              that.initialSku.cost_price = rep_sku_data.cost_price
            }
            that.$refs.sku.resetSelectedSku()
          })
          .catch(function () {
            // on cancel
            if (typeof callback == 'function') {
              callback()
            }
          })
        return
      }
    }
    if (typeof callback == 'function') {
      callback()
    }
  },
  /**手动处理规格选择（用于规格图片放大，关闭后的规格定位选择） */
  selectedSkuHandle(index, that) {
    if (index >= 0) {
      if (that.sku.list[index].stock_num > 0) {
        that.selectedSkuIndex = index
        console.log('selectedSkuHandle', that.selectedSkuIndex)
      }
      that.initialSku = that.sku.list[index]
      that.$refs.sku.resetSelectedSku()
    }
  }
}

export default skufunc



// WEBPACK FOOTER //
// ./src/assets/common/js/sku_func.js